export const ButtonNavigation = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
		name: 'button-navigation'
	};
})();
